// @flow
/**
 * Created by Mike Chung on 2/14/18.
 */
import React from "react";
import './profile.css';
import ProfileForm from "./ProfileForm";

export type Profile = {
    name: string
};

export type ProfilePageStateProps = {

}

export type ProfilePageDispatchProps = {
    onSubmit: (profile: Profile) => any
}

type ProfilePageProps = {

} & ProfilePageStateProps & ProfilePageDispatchProps;

export default function ProfilePage(props: ProfilePageProps) {
    return (
        <div id={"profile-form-container"} className={"d-flex align-items-center justify-content-center"}>
            <ProfileForm onSubmit={props.onSubmit} />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/profile/ProfilePage.js